import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [modalShow, setModalShow] = useState(false);

  const openQueryModal = () => setModalShow(true);
  const closeQueryModal = () => setModalShow(false);

  return (
    <ModalContext.Provider value={{ modalShow, openQueryModal, closeQueryModal }}>
      {children}
    </ModalContext.Provider>
  );
};





export const useModal = () => useContext(ModalContext);
